import {
  APP_STORES_LIVE,
  APP_STORE_URL,
  PLAY_STORE_URL,
  APP_COMING_SOON,
} from "@shared/appStore";

/**
 * App-store badges for the lamirage.co landing
 * (spec docs/superpowers/specs/2026-10-07-lamirage-co-landing-app-launch-design.md §1).
 *
 * While APP_STORES_LIVE is false NO official badge or store link is rendered — Apple's badge
 * guidelines forbid the App Store badge before the app is available — only a gold outline
 * "Coming soon" pill. `live` exists so tests can render both states; pages pass nothing.
 */
export default function StoreBadges({
  live = APP_STORES_LIVE,
  className = "",
}: {
  live?: boolean;
  className?: string;
}) {
  if (!live) {
    return (
      <span
        data-testid="store-badges-coming-soon"
        className={`inline-flex items-center gap-2 rounded-full border border-[#efb700]/60 px-5 py-2.5 text-sm font-semibold text-[#efb700] ${className}`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-[#efb700]" aria-hidden />
        {APP_COMING_SOON}
      </span>
    );
  }
  return (
    <div data-testid="store-badges-live" className={`flex flex-wrap items-center gap-3 ${className}`}>
      <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="inline-block">
        <img
          src="/app-launch/badge-appstore.svg"
          alt="Download on the App Store"
          width={135}
          height={45}
          className="block h-[45px] w-auto"
        />
      </a>
      <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="inline-block">
        <img
          src="/app-launch/badge-googleplay.png"
          alt="Get it on Google Play"
          width={152}
          height={59}
          className="block h-[59px] w-auto -my-[7px]"
        />
      </a>
    </div>
  );
}
